import { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

import Error404 from '../ui/views/errors/Error404'
import Loader from '../ui/views/Loader'
import * as routes from '../routes'

const HomeMobile = lazy(() => import('../context/HomeMobile'))
const ShippingDetail = lazy(() => import('../context/ShippingDetail'))
const ShippingSendMobile = lazy(() => import('../context/ShippingSendMobile'))

const MobileRouter = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route exact path={routes.HOME.path}>
          <HomeMobile />
        </Route>
        <Route exact path={routes.SHIPPING_DETAIL.path}>
          <ShippingDetail />
        </Route>
        <Route exact path={routes.SHIPPING_SEND.path}>
          <ShippingSendMobile />
        </Route>
        <Route component={Error404} />
      </Switch>
    </Suspense>
  )
}

export default MobileRouter
